import TabbedPage from '../../../Elements/TabbedPage';
import React from 'react';
import OutstandingClientInvoiceAdmin from './OutstandingClientInvoiceAdmin';
import AppliedClientInvoiceAdmin from './AppliedClientInvoiceAdmin';

export default class ClientPaymentDetailsInvoiceTab extends React.Component {
  static defaultProps = {
    clientPaymentId: 0
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  tabs = [
    {
      label: 'Outstanding Client Invoices',
      id: 'outstanding',
      icon: 'fa-solid fa-file-invoice',
      component: <OutstandingClientInvoiceAdmin clientPaymentId={this.props.clientPaymentId} />
    },
    {
      label: 'Applied Client Invoices',
      id: 'applied',
      icon: 'fa-solid fa-file-invoice-dollar',
      component: <AppliedClientInvoiceAdmin clientPaymentId={this.props.clientPaymentId} />
    }
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs} />
      </div>
    );
  }
}
